<template>
  <gg-card>
    <gg-card-header>
      Website Type
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p>Let’s get started by choosing the type of website you would like to create.</p>
          <v-radio-group v-model="websiteType">
            <v-radio
              v-for="(wt, i) in ssWebsiteTypes"
              :key="`wtr-${i}`"
              :label="wt"
              :value="wt"
              color="primary"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'WebsiteType',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite',
      ssWebsiteTypes: 'wizard_model/ssWebsiteTypes',
    }),
    websiteType: {
      get () {
        return this.starterSite.website_type
      },
      set (val) {
        this.setType(val)
      }
    },
  },
  methods: {
    ...mapMutations({
      setType: 'wizard_model/SET_SS_TYPE',
    }),
    validate () {
      return true
    }
  }
}
</script>

<style scoped>

</style>
